import { db } from '../firebase';
import { getBackendError } from 'common/utils';

const answerMapper = (documentSnapshot) => {
  const { name, isCorrect, subcategoryUid, questionUid, image } = documentSnapshot.data();

  return {
    id: documentSnapshot.id,
    subcategoryUid,
    questionUid,
    image,
    name,
    isCorrect,
  };
};

const answerListMapper = (docs) => {
  return docs.map((documentSnapshot) => answerMapper(documentSnapshot));
};

export const getAnswersListById = async (questionUid) => {
  return new Promise((resolve, reject) => {
    db
      .collection('answer')
      .where('questionUid', '==',  questionUid)
      .get()
      .then((querySnapshot) => resolve(answerListMapper(querySnapshot.docs)))
      .catch((error) => {
        reject(getBackendError(error));
      });
  });
};

export const updateAnswer = async (
  id,
  isCorrect,
  subcategoryUid,
  nameEn,
  nameRu,
  nameUk,
  namePl,
  nameIt,
  nameEs,
  namePt
  ) => {
  return new Promise((resolve, reject) => {
    db
      .collection('answer')
      .doc(id)
      .update({
        isCorrect,
        subcategoryUid,
        name: {
          en: nameEn,
          ru: nameRu,
          uk: nameUk,
          pl: namePl,
          it: nameIt,
          es: nameEs,
          pt: namePt,
        },
      })
      .then(() => resolve())
      .catch((error) => {
        reject(getBackendError(error));
      });
  });
};

export const updateAnswerImage = (id, image) => {
  return new Promise((resolve, reject) => {
    db
      .collection('answer')
      .doc(id)
      .update({
        image
      })
      .then(() => resolve())
      .catch((error) => {
        reject(getBackendError(error));
      });
  });
};

export const deleteAnswer = (id) => {
  return new Promise((resolve, reject) => {
    db
      .collection('answer')
      .doc(id)
      .delete()
      .then(() => resolve())
      .catch((error) => {
        reject(getBackendError(error));
      });
  });
};

export const createAnswer = (
  questionUid,
  subcategoryUid,
  isCorrect,
  nameEn,
  nameRu,
  nameUk,
  namePl,
  nameIt,
  nameEs,
  namePt,
) => {
  return new Promise((resolve, reject) => {
    db
      .collection('answer')
      .add({
        questionUid,
        subcategoryUid,
        isCorrect,
        name: {
          en: nameEn,
          ru: nameRu,
          uk: nameUk,
          it: nameIt,
          pl: namePl,
          es: nameEs,
          pt: namePt
        },
        image: ''
      })
      .then(() => resolve())
      .catch((error) => {
        reject(getBackendError(error));
      });
  });
};